<template>
  <div class="row">
    <div class="col-xs-12 col-md-12">
      <card :header-text="`Inspiradores(${totalRecords})`">
        <template v-slot:card-header>
            <!-- <select class="form-control">
                <option selected disabled>Lider Merani</option>
            </select>
            <select class="form-control">
                <option selected disabled>Inspirador</option>
            </select> -->

        </template>
        <div class="table-responsive">
          <table class="table table-striped first-td-padding">
            <thead>
              <tr>
                <td>Nombre</td>
                <td>Teléfono</td>
                <td>Dirección</td>
                <td align="center">Acciones</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(inspiradores, key) in inspiradoress" :key="key">
                <td>{{ `${inspiradores.doc.nombres} ${inspiradores.doc.apellidos}` }}</td>
                <td>{{ inspiradores.doc.telefono }}</td>
                <td>{{ inspiradores.doc.direccion }}</td>
                <td align="center">
                  <router-link class="btn btn-small btn-action btn-info"
                    :to="{ name: 'ver-inspiradores', params: {id: inspiradores.id}}"
                  >
                    <i class="fa fa-eye"></i>&nbsp;
                    <span>Ver</span>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
            <paginate
              :pageCount="pageCount"
              :clickHandler="handlerPaginate"
              :prevText="'Anterior'"
              :nextText="'Siguiente'"
              :containerClass="'pagination'"
              :page-class="'page-item'"
              :page-link-class="'page-link'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
            >
            </paginate>
        </div>
      </card>
    </div>
  </div>
</template>

<script>

import { obtenerInspiradores } from '../../api/admin'
import { mapState } from 'vuex'
import paginate from 'vuejs-paginate'
import departamentos from '../../static-data/departamentos'
import municipios from '../../static-data/municipios'

export default {
  components: { paginate },
  data () {
    return {
      inspiradores: [],
      totalRecords: 0,
      queryParams: {
        page: 1,
        filters: {
          'departamento.codigo': undefined,
          'municipio.codigoMunicipio': undefined
        }
      }
    }
  },
  computed: {
    ...mapState('user', [
      'token',
      'user'
    ]),
    departamentos () {
      return departamentos
    },
    municipios () {
      return municipios.filter(municipio => municipio.departamento === this.queryParams.filters['departamento.codigo'])
    },
    pageCount () {
      return Math.ceil(this.totalRecords / 10)
    }
  },
  mounted () {
    this.cargarInspiradores()
  },
  methods: {
    async cargarInspiradores () {
      this.$forceUpdate()
      const data = await obtenerInspiradores(this.queryParams)
      this.inspiradores = data.results
      this.totalRecords = data.total
    },
    handlerPaginate (page) {
      this.queryParams.page = page
      this.cargarInspiradores()
    },
    handleFilterDepartamento () {
      this.queryParams.filters['municipio.codigoMunicipio'] = undefined
      this.cargarInspiradores()
    }
  }
}
</script>
<style lang="scss">
  .table thead tr{
    color: #007bff;
  }
  .error-icon{
    color: #e34a4a;
  }
  .success-icon {
    display: inline-block;
    color: #4ae387;
  }
  .table-sm th, .table-sm td{
    padding: .7rem;
  }
  .color-icon-label-table {
    td:first-child {
      width: 1rem;
    }
  }
  .btn-small {
    font-size: 12px;
  }
  .btn-action {
    margin-right: 10px;
    padding: 4px 8px;
    &:last-child {
      margin-right: 0;
    }
    @media screen and (max-width: 992px) {
      span {
        display: none;
      }
    }
  }
</style>
